import { render, staticRenderFns } from "./CouponValid.vue?vue&type=template&id=6df56b20&scoped=true"
import script from "./CouponValid.vue?vue&type=script&lang=js"
export * from "./CouponValid.vue?vue&type=script&lang=js"
import style0 from "./CouponValid.vue?vue&type=style&index=0&id=6df56b20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df56b20",
  null
  
)

export default component.exports